import { NgModule } from '@angular/core';
import { MoveOnChangelengthDirective } from './move-on-change-length/move-on-change-length';
import { ClickOutsideDirective } from './click-outside/click-outside';
import { NativeAutofillDetector } from './autoFill/autoFill.directive';

@NgModule({
  declarations: [
    MoveOnChangelengthDirective,
    ClickOutsideDirective,
    NativeAutofillDetector
  ],
  imports: [
  ],
  exports: [
    MoveOnChangelengthDirective,
    ClickOutsideDirective,
    NativeAutofillDetector
  ]
})
export class DirectivesModule {}
